import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import XLSX from "xlsx";
import Button from "@material-ui/core/Button";

import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";

class Users extends Component {
	constructor(props) {
		super(props);
		this.state = {
			columnDefs: [
				{ headerName: "Nombre", field: "name", width: "150" },
				{ headerName: "Apellido", field: "lastname", width: "150" },
				{ headerName: "Email", field: "email", width: "150" },
				{ headerName: "Xp", field: "xp", width: "150" },
				{ headerName: "Total Respuestas", field: "totalanswers", width: "150" },
				{
					headerName: "Respuestas Correctas",
					field: "correctanswers",
					width: "180"
				}
			]
		};
	}

	exportFile = () => {
		/* convert state to workbook */
		let cols = this.props.users.map((info, i) => {
			return [
				info.nombre,
				info.apellido,
				info.email,
				info.xp,
				info.totalanswers,
				info.correctanswers
			];
		});
		let hcols = [
			"Nombre",
			"Apellido",
			"e-mail",
			"XP",
			"Total Respuestas",
			"Respuestas Correctas"
		];
		const exp = [[...hcols], ...cols];
		const ws = XLSX.utils.aoa_to_sheet(exp);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Usuarios");
		/* generate XLSX file and send to client */
		XLSX.writeFile(wb, "Usuarios.xlsx");
	};

	componentDidMount() {}

	render() {
		return (
			<React.Fragment>
				<h2 style={{ width: "100%", textAlign: "left" }}>Usuarios</h2>
				<div style={{ width: "100%", textAlign: "left", marginBottom: "20px" }}>
					{" "}
					<Button
						onClick={this.exportFile}
						color="primary"
						variant="contained"
						style={{ backgroundColor: "#7C9EB2" }}
					>
						Exportar a Excel
					</Button>
				</div>
				<div
					className="ag-theme-balham"
					style={{ height: "80vh", width: "100%" }}
				>
					<AgGridReact
						enableSorting={true}
						enableFilter={true}
						columnDefs={this.state.columnDefs}
						rowData={this.props.users}
					></AgGridReact>
				</div>
			</React.Fragment>
		);
	}
}

export default Users;
